import { Pipe, PipeTransform } from '@angular/core';

import * as _ from 'lodash';

import { CurrencyConstants } from '../models/constants/currency.constants';
import { LocaleConstants } from '../models/constants/locale.constants';
import { AppSettingsService } from './../services/app-settings/app-settings.service';

@Pipe({
  name: 'priceFormatter',
})
export class PriceFormatterPipe implements PipeTransform {

  private thousandsSeparator: string;
  private decimalSeparator: string;

  constructor(private appSettingsService: AppSettingsService) {
    this.thousandsSeparator = this.getThousandsSeparator();
    this.decimalSeparator = this.getDecimalSeparator();
  }

  transform(value: number, decimals: number = 0): string {
    const numberValue: number = value;

    if (!_.isUndefined(numberValue)) {
      const price = this.formatPrice(numberValue, decimals);
      return `${price}`;
    }
    return '';
  }

  private formatPrice(price: number, decimals: number): string {
    const parts = _.toString(price).split('.');
    let formatted = _.replace(parts[0], /\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    if (decimals > 0) {
      formatted += this.decimalSeparator;
      formatted += ((parts[1] === undefined ? "" : parts[1]) + Array(decimals + 1).join('0')).slice(0, decimals);
    }
    return formatted;
  }

  private getThousandsSeparator(): string {
    switch (this.appSettingsService.getLocale().replace('_', '-')) {
      case LocaleConstants.EEUU:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.EL_SALVADOR:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.GUATEMALA:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.HONDURAS:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.MEXICO:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.NICARAGUA:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.PANAMA:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      case LocaleConstants.PUERTO_RICO:
        return CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
      default:
        return CurrencyConstants.THOUSANDS_SEPARATOR_DOT;
    }
  }

  private getDecimalSeparator(): string {
    return this.thousandsSeparator === CurrencyConstants.THOUSANDS_SEPARATOR_COMMA ?
      CurrencyConstants.THOUSANDS_SEPARATOR_DOT :
      CurrencyConstants.THOUSANDS_SEPARATOR_COMMA;
  }
}
